export interface SettingsHubItem {
  titulo: string;
  descricao: string;
  /** Caminho para um ícone em /public/icons */
  icone: string;
  /** Rota relativa a /configuracoes */
  rota: string;
  /**
   * Roles/permissões Keycloak necessárias para ver esta configuração.
   * Ligar aqui à role/claim correta do utilizador (appHasAnyRole usa a mesma lista).
   */
  permissoes: string[];
}

/**
 * Fonte única das configurações disponíveis na página hub de Configurações.
 * Para adicionar uma nova configuração, basta acrescentar um item aqui —
 * não é preciso alterar o template do hub.
 */
export const SETTINGS_HUB_ITEMS: SettingsHubItem[] = [
  {
    titulo: 'Período de Renovação de Matrícula',
    descricao:
      'Defina os períodos em que os bolseiros podem submeter a renovação de matrícula.',
    icone: 'icons/calendar.svg',
    rota: 'periodo-renovacao',
    permissoes: ['CONFIGURAÇÕES', 'PERÍODO DE RENOVAÇÃO'],
  },
];
